import type { VNode } from 'preact'
import * as React from 'preact/compat'
import Loading from './Loading'
import Modal from './Modal'
import { captureFetchException } from '../common/helpers'
import { showToast } from './toast'

export interface AsyncModalTagProps {
  href: string,
  method?: string,
  formData?: FormData,
}

export type AsyncModalProps = AsyncModalTagProps & {
  onClose: () => void
}

interface AsyncModalState {
  content: string | VNode
}

export default class AsyncModal extends React.Component<AsyncModalProps, AsyncModalState> {
  state: AsyncModalState = {
    content: <Loading/>,
  }
  content = React.createRef<HTMLDivElement>()

  componentDidMount() {
    this.load()
  }

  load = () => {
    const { href, method, formData } = this.props

    if (/\.(jpg|jpeg|gif|png|webp|svg)$/.test(href)) {
      this.setState({
        content: `<img alt='' src="${href}" />`
      })
      return
    }

    const init: RequestInit = {}

    if (typeof method !== 'undefined' && method !== 'get') {
      init.method = method
    }

    if (method === 'post' && typeof formData !== 'undefined') {
      init.body = formData
    }

    fetch(href, init)
      .then(res => {
        if (!res.ok) {
          throw new Error(res.statusText)
        }
        return res.text()
      })
      .then(content => {
        this.setState({
          content
        })
      })
      .catch(error => {
        captureFetchException(error)
        showToast({
          type: 'error',
          text: 'При открытии модального окна произошла ошибка',
        })
        this.props.onClose()
      })
  }

  componentDidUpdate(_prevProps: AsyncModalProps, prevState: AsyncModalState) {
    const { content } = this.state
    if (typeof prevState.content !== 'string') {
      React.unmountComponentAtNode(this.content.current)
    }

    if (typeof content === 'string') {
      const slotHtml = document.createRange().createContextualFragment(content)
      this.content.current.innerHTML = ''
      this.content.current.appendChild(slotHtml)
      this.content.current.querySelectorAll('[data-async-modal-close]').forEach(element => {
        element.addEventListener('click', this.props.onClose)
      })
    } else {
      React.render(content, this.content.current)
    }
  }

  render() {
    return <Modal showClose onClose={this.props.onClose}>
      <div ref={this.content}/>
    </Modal>
  }
}
